import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
const DatePickerImpl = lazy(() => import('./DatePickerImpl'));
function DatePicker(props) {
    return (_jsx(Suspense, { fallback: _jsx("div", { className: "date-picker-container" }), children: _jsx(DatePickerImpl, { ...props }) }));
}
export default DatePicker;
